// Entry point for the new Stimulus-based design system.
// Only controllers required by the design system page should be registered
// here while the redesign is rolled out incrementally.
import { Application } from '@hotwired/stimulus'

import ClipboardController from './clipboard_controller'
import AutogrowController from './autogrow_controller'
import CheckboxAllController from './checkbox_all_controller'
import ButtonLoadingController from './button_loading_controller'
import PasswordToggleController from './password_toggle_controller'
import SelectController from './select_controller'
import DatepickerController from './datepicker_controller'
import DropdownController from './dropdown_controller'
import ModalController from './modal_controller'
import MobileNavController from './mobile_nav_controller'
import WorkListSearchController from './work_list_search_controller'
import WorkListPriceController from './work_list_price_controller'
import WorkListSelectionController from './work_list_selection_controller'
import BulkCancelController from './bulk_cancel_controller'
import WorkListNotesController from './work_list_notes_controller'
import JobNotesController from './job_notes_controller'
import JobNotesFabController from './job_notes_fab_controller'
import JobCancelController from './job_cancel_controller'
import CustomerQuickSearchController from './customer_quick_search_controller'
import WeeksIndexController from './weeks_index_controller'
import WeekJobsController from './week_jobs_controller'
import WorklistRenameController from './worklist_rename_controller'
import WeekMapController from './week_map_controller'
import WorkListsIndexController from './work_lists_index_controller'

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register('clipboard', ClipboardController)
application.register('autogrow', AutogrowController)
application.register('checkbox-all', CheckboxAllController)
application.register('button-loading', ButtonLoadingController)
application.register('password-toggle', PasswordToggleController)
application.register('select', SelectController)
application.register('datepicker', DatepickerController)
application.register('dropdown', DropdownController)
application.register('modal', ModalController)
application.register('mobile-nav', MobileNavController)
application.register('work-list-search', WorkListSearchController)
application.register('work-list-price', WorkListPriceController)
application.register('work-list-selection', WorkListSelectionController)
application.register('bulk-cancel', BulkCancelController)
application.register('work-list-notes', WorkListNotesController)
application.register('job-notes', JobNotesController)
application.register('job-notes-fab', JobNotesFabController)
application.register('job-cancel', JobCancelController)
application.register('customer-quick-search', CustomerQuickSearchController)
application.register('weeks-index', WeeksIndexController)
application.register('week-jobs', WeekJobsController)
application.register('worklist-rename', WorklistRenameController)
application.register('week-map', WeekMapController)
application.register('work-lists-index', WorkListsIndexController)

export default application
